export class TrailerType {
  constructor(trailerType = {}) {
    this.id = trailerType.id;
    this.name = trailerType.name;
  }
}
